import CareerAbout from './career-about';

export default class CareerAboutDesktop extends CareerAbout {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/career/about/career-about.desktop.js